import axios from 'axios'

export const getPostcodeList = async (): Promise<string> => {
  const url = '/postcode_list.csv'

  const response = await axios.get(url)
  return response.data
}
